import request from '@/utils/request'
import store from '../store'
import { feedbackHost } from './index'
import {root, root2, root3} from '../utils/chHostconfig'

const BASE_URL = '/api'
const checkVideoUrl = '//check-video.classba.cn/'
const login = data => {
  return request({
    url: BASE_URL+ '/student/loginIn',
    method: 'post',
    data
  })
}

const nextStep = data => {
  return request({
    url: BASE_URL + '/cn/flow/go',
    method: 'post',
    data
  })
}

const submitAnswer = data => {
  return request({
    url: BASE_URL + '/cn/flow/submitQuestion',
    method: 'post',
    data
  })
}

const correct = data => {
  return request({
    url: BASE_URL + '/cn/api/correct',
    method: 'post',
    data
  })
}

const submitWelcome = data => {
  return request({
    url: BASE_URL + '/cn/event/submitInitStatus',
    method: 'post',
    data: {
      topicId: store.state.topic.topicId,
      initStatus: data
    }
  })
}

const submitError = data => {
  return request({
    url: BASE_URL + '/cn/event/submitError',
    method: 'post',
    data
  })
}

const getReportData = data => {
  return request({
    url: BASE_URL + '/cn/report/getModuleReport',
    method: 'post',
    data
  })
}

const getReportCenter = data => {
  return request({
    url: BASE_URL + '/cn/flow/reportCenter',
    method: 'post',
    data
  })
}

const getAllQuestion = data => {
  return request({
    url: BASE_URL + '/cn/report/getModuleQuestionList',
    method: 'post',
    data
  })
}
const submitInitStatus = data => {
  return request({
    url: BASE_URL + '/cn/event/submitInitStatus',
    method: 'post',
    data
  })
}

const getTransitionReport = data => {
  return request({
    url: BASE_URL + '/cn/report/getTransitionReport',
    method: 'post',
    data
  })
}

const submitGuideEnmu = data => {
  return request({
    url: BASE_URL + '/cn/event/submitGuideEnmu',
    method: 'post',
    data
  })
}

const checkVideo = url => {
  return request({
    baseURL: checkVideoUrl,
    url: 'video_m3u8.php?u=' + encodeURIComponent(url)
  })
}

const getCompare = data => {
  return request({
    baseURL: BASE_URL + '/cn/report/getCompare',
    method: 'post',
    data
  })
}

const checkCompareApi = data => {
  return request({
    baseURL: BASE_URL + '/cn/report/checkCompare',
    method: 'post',
    data
  })
}

const applyLessonTime = data => {
  return request({
    url: BASE_URL + '/cn/flow/applyStudyTime',
    method: 'post',
    data
  })
}

const getAddCrystal = data => {
  return request({
    url: feedbackHost + '/game/embrave/notify',
    // url: 'http://game-api.test.classba.en/embrave/notify',
    method: 'post',
    data
  })
}

const selfEvaluation = data => {
  return request({
    url: BASE_URL + '/cn/api/selfEvaluation',
    method: 'post',
    data
  })
}



const getCorrectData = data =>  {
  return request({
    url: BASE_URL + '/cn/api/getCorrectData',
    method: 'post',
    data
  })
}

const getUserTag = data => {
  return request({
    url: feedbackHost+ '/api/getUserTag',
    method: 'post',
    data
  })
}
/**
 * 辅助输入获取token、上传图片、语音
 */
const getAuxiliaryInput = params => {
  return request({
    url: root + '/flow/go',
    method: 'post',
    data: params
  })
}
const getMobileUploadPic = params => {
  return request({
    url: root + '/?c=Upload&a=image',
    method: 'post',
    ...params
  })
}
const pollingPicAndAudio = params => {
  return request({
    url: root3 + '/?c=Polling&a=get',
    method: 'post',
    data: params
  })
}
const getUploadAudio = params => {
  return request({
    url: root3 + '/?c=SpeechToText&a=index',
    method: 'post',
    ...params
  })
}
const getSelfEval = params => {
  return request({
    url: root + '/flow/go',
    method: 'post',
    data: params
  })
}
const getWacomToken = params => { // 获取主观题辅助输入token
  return request({
    url: BASE_URL + '/cn/api/getWacomToken',
    method: 'post',
    data: params
  })
}

const getQuestionAnalyze = data => { // 获取解析数据
  return request({
    url: BASE_URL + '/cn/api/getQuestionAnalyze',
    method: 'post',
    data
  });
};

const applyCorrect = data => { // 申请人工批改
  return request({
    url: BASE_URL + '/cn/api/applyCorrect',
    method: 'post',
    data
  });
};

export {
  login,
  nextStep,
  submitAnswer,
  getReportData,
  getReportCenter,
  submitWelcome,
  getAllQuestion,
  submitError,
  submitInitStatus,
  getTransitionReport,
  submitGuideEnmu,
  checkVideo,
  checkCompareApi,
  getCompare,
  applyLessonTime,
  getAddCrystal,
  getUserTag,
  correct,
  getCorrectData,
  getSelfEval,
  getUploadAudio,
  pollingPicAndAudio,
  getMobileUploadPic,
  getAuxiliaryInput,
  getWacomToken,
  selfEvaluation,
  getQuestionAnalyze,
  applyCorrect
}



// WEBPACK FOOTER //
// ./src/api/base.js